module.exports = {
	"name": {
		"family": "Radonctest",
		"given": "Veera",
		"prefix": "",
		"suffix": ""
	},
	"careProvider": "10",
	"phone": "608-999-9654",
	"address": {
		"line": "1855 Folsom Street",
		"city": "San Francisco",
		"district": "DANE",
		"state": "Wisconsin",
		"postalCode": "53703",
		"country": "United States of America"
	}
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/json-loader!./src/www/resources/patient-info-portal-response.json
 ** module id = 902
 ** module chunks = 0
 **/